import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M2217 8423 c-4 -3 -7 -1402 -7 -3109 l0 -3102 23 -6 c33 -9 3400 -7
3414 2 9 6 -15 46 -82 137 -144 196 -360 489 -435 590 -37 50 -140 189 -230
310 -240 322 -555 743 -655 875 -205 268 -254 331 -347 450 -55 69 -111 140
-126 159 -73 94 -244 306 -315 391 -43 52 -81 100 -84 107 -4 9 95 164 140
218 7 9 110 154 297 421 41 59 95 136 120 170 25 35 101 143 170 241 69 97
184 260 257 363 72 102 145 205 163 230 17 25 75 106 128 181 53 75 131 185
172 243 41 59 91 129 110 156 51 72 211 296 242 340 14 21 75 107 134 192 59
84 150 214 202 288 52 74 97 140 99 147 4 11 -330 13 -1689 13 -932 0 -1698
-3 -1701 -7z"
          />
          <path
            d="M6030 8048 c-24 -35 -135 -200 -248 -368 -480 -713 -737 -1082 -1290
-1845 -56 -77 -108 -149 -116 -160 -8 -11 -41 -56 -73 -100 -32 -44 -74 -101
-91 -127 l-33 -48 30 -42 c17 -24 107 -144 202 -268 94 -124 218 -288 276
-365 57 -77 110 -147 116 -155 7 -8 24 -31 38 -50 56 -75 235 -319 284 -385
28 -38 94 -128 147 -200 141 -193 561 -775 641 -890 39 -55 125 -176 192 -270
67 -93 176 -248 244 -343 l122 -172 42 21 c131 67 376 239 547 384 110 93 326
316 413 425 207 260 365 521 482 795 87 205 157 431 170 550 4 33 15 92 25
130 11 39 24 122 30 185 5 63 12 134 15 158 3 29 1 42 -8 42 -7 0 -50 -31 -97
-69 -167 -134 -301 -321 -382 -533 -27 -72 -37 -88 -54 -88 -31 0 -337 69
-346 78 -16 16 47 204 113 335 142 280 420 558 686 687 40 19 74 40 76 45 6
17 -23 249 -33 259 -8 8 -194 -77 -250 -114 -14 -9 -45 -30 -70 -46 -347 -222
-634 -579 -770 -959 -18 -49 -37 -102 -42 -117 -12 -32 -23 -33 -98 -14 -49
13 -177 40 -253 53 -16 3 -31 12 -34 19 -14 36 101 334 196 509 35 66 68 124
73 130 4 5 38 53 75 105 141 200 319 384 529 542 63 48 279 183 317 197 93 37
236 113 232 123 -2 7 -20 66 -40 131 -22 70 -43 121 -52 124 -30 12 -288 -114
-468 -227 -331 -208 -638 -511 -857 -844 -105 -160 -226 -409 -283 -581 -26
-77 -48 -142 -50 -144 -2 -1 -92 16 -201 40 -129 29 -198 48 -202 58 -13 35
82 300 183 506 188 387 480 755 810 1021 33 26 62 51 65 54 6 6 97 73 165 122
135 96 384 234 600 333 41 19 75 36 75 39 0 13 -146 236 -212 324 -97 129
-189 232 -333 372 -201 196 -458 376 -731 513 -148 74 -403 177 -439 177 -7 0
-32 -28 -55 -62z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
